import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/AuthState';

/**
 * Returns `true` once the persisted auth store has finished hydrating from
 * Capacitor Preferences (async storage). Gate the first render on this so the
 * app never flashes a logged-out state before the persisted token is read.
 */
export const useAuthHydrated = (): boolean => {
  const [hydrated, setHydrated] = useState(() => useAuthStore.persist.hasHydrated());

  useEffect(() => {
    const unsubFinish = useAuthStore.persist.onFinishHydration(() => setHydrated(true));
    if (useAuthStore.persist.hasHydrated()) setHydrated(true);
    return unsubFinish;
  }, []);

  return hydrated;
};
